import {useState, useEffect, useMemo} from 'react'
import {useGetAllOnlyOrgs, useGetOrgDetails} from 'modules/organisations'
import AddNewOrgForm from 'modules/organisations/components/OrgDetailsForm'
// import {useGetAllUsers} from 'modules/users'
import {
  Button,
  Form,
  FormItem,
  Select,
  UserItem,
  useForm,
  useWatch,
  Box,
  Modal,
  ButtonLink,
} from 'common/components'
// import {FIELD_RULES} from 'common/constants'
import {useAssignBorrower} from '..'

interface BorrowerAssignFormProps {
  projectUuid: string
  onClose: () => void
  org?: any
  members?: {
    Editor: any[]
    Viewer: any[]
  }
}

export default function BorrowerAssignForm({
  projectUuid,
  onClose,
  org: initOrg,
  members: initMembers
}: BorrowerAssignFormProps) {
  const [form] = useForm()
  const [currentOrgId, setCurrentOrgId] = useState<string>('')
  const {data: currentOrgData} = useGetOrgDetails({
    uuid: currentOrgId
  })
  const {data: orgsData, isLoading: isOrgLoading} = useGetAllOnlyOrgs({
    type: 'borrower'
  })
  // const {data: orgsData, isLoading: isOrgLoading} = useGetOrganisations({
  //   type: 'borrower'
  // })
  const orgs = orgsData?.data
  // console.log(orgs)
  // console.log(initOrg)
  // const {data: members, isLoading: isMemberLoading} = useGetAllUsers('borrowers', 'user')
  const [isSelect1Open, setSelect1Open] = useState(false)
  const [isSelect2Open, setSelect2Open] = useState(false)
  const [isSelectOpen, setSelectOpen] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)

  const handeSelectOpenSet = (open: boolean) => setSelectOpen(open)
  const handleModalClose = () => setModalOpen(false)
  const handleModalOpen = () => {
    setSelectOpen(false)
    setModalOpen(true)
  }

  const {mutate: assignBorrower, isMutating: isAssignBorrowerMutating} =
    useAssignBorrower(projectUuid, onClose)

  const handleFinish = (values: any) => { assignBorrower(values) }
  const handeSelect1OpenSet = (open: boolean) => setSelect1Open(open)
  const handeSelect2OpenSet = (open: boolean) => setSelect2Open(open)

  // const handleModalOpen = () => {
  //   setSelect1Open(false)
  //   setSelect2Open(false)
  //   setModalOpen(true)
  // }
  // const handleModalClose = () => setModalOpen(false)

  const orgOptions = orgs?.filter(
    (org:any) => !!org.name
  ).map(
    (org:any) => ({
      value: org.uuid || org.id,
      label: <UserItem user={org} />,
      textLabel: org.name,
    })
  ).sort(
    (a:any, b:any) => (a.textLabel as string).localeCompare(b.textLabel)
  ) || []

  const borrowerId = useWatch('borrower', form)
  // const editorsValue = useWatch('editors', form)
  // const viewersValue = useWatch('viewers', form)
  useEffect(() => {
    form.setFieldValue('editors', [])
    form.setFieldValue('viewers', [])
    if (!!borrowerId) {
      setCurrentOrgId(borrowerId)
    }
  }, [borrowerId, form])


  // const theBorrower = orgs?.find((x:any) => x.id === borrowerId)
  const theBorrower = currentOrgData?.data
  // console.log(theBorrower)
  // console.log(currentOrgData)

  const members:any[] = theBorrower?.users
  // console.log(borrowerId, theBorrower, members)
  // console.log(initMembers)
  const memberOptions = members?.filter(
    (member) => member.firstName || member.lastName
  ).map(
    (member) => ({
      value: member.uuid,
      label: <UserItem user={member} />,
      textLabel: `${member.firstName} ${member.lastName}`,
    })
  ) || []

  const openNewWindow = () => {
    onClose?.()
    window.open(`/org/details/${borrowerId}`, '_blank', 'noreferrer');
  }
  // console.log(members)
  const initValues = useMemo(() => (
    !initOrg?.id ? undefined : {
      borrower: initOrg.id,
      editors: initMembers?.Editor?.map((x:any) => x.id) || [],
      viewers: initMembers?.Viewer?.map((x:any) => x.id) || [],
    }
  ), [initOrg, initMembers])
  useEffect(() => {
    // This is the bug workaround
    // initValues for multi-select, doesn't work in normal way
    setTimeout(() => {
      form.setFieldValue('editors', initValues?.editors || [])
      form.setFieldValue('viewers', initValues?.viewers || [])
    }, 200);
  }, [form, initValues])

  return (
    <>
    <Form 
      form={form}
      initialValues={initValues} onFinish={handleFinish}
    >
      <FormItem name="borrower" label="Select the borrower" 
        // rules={FIELD_RULES}>
      > 
        <Select
          autoFocus
          showSearch
          optionFilterProp="textLabel"

          loading={isOrgLoading}
          options={orgOptions}

          open={isSelectOpen}
          onDropdownVisibleChange={handeSelectOpenSet}
          dropdownRender={(menu) => (
            <>
              {menu}
              <>
                <Box pl={14} mt={12}>
                  <ButtonLink onClick={handleModalOpen}>
                    Add new borrower…
                  </ButtonLink>
                </Box>
              </>
            </>
          )}
        />
      </FormItem>
      <FormItem
        name="editors"
        label="Assign editors"
        // rules={ !viewersValue?.length ? FIELD_RULES : undefined}
      >
        <Select
          mode="multiple"
          showSearch
          placeholder="Search user"
          optionFilterProp="textLabel"
          loading={false} // isMemberLoading}
          options={memberOptions}
          open={isSelect1Open}
          dropdownRender={(menu) => (
            <>
              {menu}
              { !!borrowerId &&
                <Box pl={14} mt={12}>
                  <ButtonLink onClick={openNewWindow}>
                    Add new member…
                  </ButtonLink>
                </Box>
              }
            </>
          )}
          onDropdownVisibleChange={handeSelect1OpenSet}
        />
      </FormItem>
      <FormItem
        name="viewers"
        label="Assign viewers"
        // rules={!editorsValue?.length ? FIELD_RULES : undefined}
      >
        <Select
          mode="multiple"
          showSearch
          placeholder="Search user"
          optionFilterProp="textLabel"
          loading={false} // isMemberLoading}
          options={memberOptions}
          open={isSelect2Open}
          dropdownRender={(menu) => (
            <>
              {menu}
              { !!borrowerId &&
                <Box pl={14} mt={12}>
                  <ButtonLink onClick={openNewWindow}>
                    Add new member…
                  </ButtonLink>
                </Box>
              }
            </>
          )}
          onDropdownVisibleChange={handeSelect2OpenSet}
        />
      </FormItem>
      <Box align="right">
        <Button
          className='Button_type_form Button_type_form_cancel'
          loading={isAssignBorrowerMutating}
          onClick={onClose}
        >
          Cancel
        </Button>
        &nbsp;
        <Button className='Button_type_form Button_type_form_submit'
          htmlType="submit"
          loading={isAssignBorrowerMutating}
        >
          Confirm
        </Button>
      </Box>
    </Form>
    <Modal
      title="Add new borrower"
      open={isModalOpen}
      onCancel={handleModalClose}
    >
      <AddNewOrgForm
        onClose={handleModalClose}
        defaultOrgType="borrower"
      />
    </Modal>
    </>
  )
}
